import React from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { fetchAccount } from "../../../../redux/slices/account";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import {
  Box,
  Typography as MuiTypography,
  Divider as MuiDivider,
  Grid,
} from "@mui/material";

import LocationSettingsTable from "./locationSettings/LocationSettingsTable";
const Divider = styled(MuiDivider)(spacing);
const Typography = styled(MuiTypography)(spacing);
const TitleTypography = styled(Typography)`
  margin-top: 15px;
  padding-right: 20px;
  padding-bottom: 12px;
  color: ${(props) => props.theme.sidebar.header.color};
`;
const Wrapper = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

const Ptypography = styled(Typography)`
  margin-top: 15px;
  padding-right: 20px;
`;

const LocationSettings = () => {
  // const { data: account, status } = useSelector((state) => state.account);
  const fetchAccountData = useSelector(
    (state) => state.account.fetchAccountData
  );
  const dispatch = useDispatch();

  const [accountData, setAccountData] = useState({});

  React.useEffect(() => {
    dispatch(fetchAccount());
  }, [dispatch]);

  React.useEffect(() => {
    if (fetchAccountData.status === "success" && fetchAccountData?.data) {
      setAccountData(fetchAccountData.data);
    }
  }, [fetchAccountData]);

  return (
    <>
      <Box
        style={{
          backgroundColor: "#F9F9F9",
          height: "92vh",
          borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <Wrapper>
          <TitleTypography variant="h4">
            <AddLocationIcon /> LocationSettings
          </TitleTypography>
        </Wrapper>
        <Divider my={2} sx={{ borderBottomWidth: 2 }} />
        <Wrapper>
          <Grid container>
            <Grid item xs={12} lg={9}>
              <Box
                style={{
                  backgroundColor: "#F9F9F9",
                  height: "92vh",
                  borderRight: "1px solid rgba(0, 0, 0, 0.12)",
                }}
              >
                <LocationSettingsTable accountData={accountData} />
              </Box>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Box
                style={{
                  padding: "10px",
                  backgroundColor: "#F9F9F9",
                  height: "92vh",
                }}
              >
                <Typography gutterBottom variant="h5" component="h2">
                  Location Settings
                </Typography>
                <Ptypography component="p">
                  A Location Settings tracks facts about your Location Setting —
                  like the Location Name, or description of location and icon.
                </Ptypography>
                <Ptypography component="p">
                  For creating a Custom Attribute, just click on the Add
                  Location Settings. You can also edit or delete an existing
                  Location Setting by clicking on the Edit or Delete button.
                </Ptypography>
              </Box>
            </Grid>
          </Grid>
        </Wrapper>
      </Box>
    </>
  );
};

export default LocationSettings;
